import { AxisChartAPI } from '../axis-chart/axis-chart-api.js';
class AreaChartAPI extends AxisChartAPI {
    /**
     * Returns the areas of the chart.
     */
    getAreas() {
        return this.state.areas;
    }
    /**
     * Sets the areas of the chart.
     *
     * @param areas - The chart areas.
     */
    setAreas(areas) {
        this.setState({ areas });
    }
    /**
     * Returns the active dot of the chart.
     */
    getActiveDot() {
        return this.state.activeDot;
    }
    /**
     * Sets the active dot of the chart.
     *
     * @param activeDot - The active dot.
     */
    setActiveDot(activeDot) {
        this.setState({ activeDot });
    }
    /**
     * Returns the chart dot.
     */
    getDot() {
        return this.state.dot;
    }
    /**
     * Sets the chart dot.
     *
     * @param dot - The chart dot.
     */
    setDot(dot) {
        this.setState({ dot });
    }
}
export { AreaChartAPI, };
//# sourceMappingURL=area-chart-api.js.map